<div class="flex flex-wrap items-center gap-2">
  @for (tag of tags(); track tag) {
    <span class="bg-primary-50 text-primary-600 inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm">
      {{ tag }}
      @if (!readonly()) {
        <button
          type="button"
          class="text-primary-400 hover:text-primary-600 flex items-center"
          (click)="removeTag(tag)"
        >
          <mat-icon style="font-size: 1rem; width: 1rem; height: 1rem">close</mat-icon>
        </button>
      }
    </span>
  } @empty {
    <span class="text-sm text-neutral-400">{{ "protocols.coverage.empty" | translate }}</span>
  }
</div>

@if (!readonly()) {
  <div class="mt-2 flex items-center gap-2">
    <input
      class="form-input w-full max-w-xs rounded-md border border-neutral-200 px-3 py-2 text-sm"
      type="text"
      [value]="draft()"
      [placeholder]="'protocols.coverage.placeholder' | translate"
      (input)="onInput($event)"
      (keydown.enter)="$event.preventDefault(); addTag()"
    />
    <button
      type="button"
      class="btn btn-secondary"
      (click)="addTag()"
    >
      {{ "protocols.coverage.add" | translate }}
    </button>
  </div>
}
